/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Matching/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import SyncToolLoader from 'DesignSystem/SyncToolLoader/react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Matching({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/IntegrationsApplications/Content/SyncPatients/Content/Matching"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let syncMatchingPageValueData = fromData.useDataValue({ viewPath,
context: 'sync',
path: 'matchingPage',
})
let constantData = 'Processing page:'
let syncMatchingPageValueData1 = fromData.useDataValue({ viewPath,
context: 'sync',
path: 'matchingPage',
})
let aggregateData = fromAggregate.join(constantData, syncMatchingPageValueData1)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Matching.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<SyncToolLoader
  viewPath={`${viewPath}/SyncToolLoader`}
/>
<div
  data-testid="Matching.Vertical:1"
  data-view-path={viewPath}
 style={{'--mb-1-q6V6m': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Matching.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-q6V6m': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 text="Matching in progress..."
/>
<fromFlow.When is={syncMatchingPageValueData}>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 data="sync.matchingPage"
 data="'Processing page:'"
 data="sync.matchingPage"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
 level="h3"
 marginLeft={dtSpaceXs}
/>
</fromFlow.When>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="We are matching the patients in Greyfinch to the patients in the 3rd party app."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="This may take some time, so if you have other things to do, you can come back to this page later to see the results."
/>
</div>
</div>
{children}
</React.Fragment>)
}